import { createReducer } from '@reduxjs/toolkit';
import { getPrivacyPolicy } from '../actions/privacyPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getPrivacyPolicy.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
